import { useState, useCallback } from "react";
import {
  CreditSummaryEntity,
  ListParams,
  PaginatedResponse,
} from "../../domain/entities/CreditSummaryEntity";
import { recoContainer } from "../../di/container";

export const useCreditsList = (entityType: "customer" | "vendor") => {
  const [credits, setCredits] = useState<CreditSummaryEntity[]>([]);
  const [pagination, setPagination] = useState<PaginatedResponse<CreditSummaryEntity>["pagination"] | null>(
    null
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchList = useCallback(
    async (params: ListParams) => {
      try {
        setLoading(true);
        setError(null);

        let response: PaginatedResponse<CreditSummaryEntity>;

        if (entityType === "customer") {
          const useCase = recoContainer.getCustomerCreditsList();
          response = await useCase.execute(params);
        } else {
          const useCase = recoContainer.getVendorCreditsList();
          response = await useCase.execute(params);
        }

        setCredits(response.data);
        setPagination(response.pagination);
      } catch (err: any) {
        setError(
          err.message || `Failed to fetch ${entityType} credits list`
        );
        console.error(`Error fetching ${entityType} credits list:`, err);
      } finally {
        setLoading(false);
      }
    },
    [entityType]
  );

  return {
    credits,
    pagination,
    loading,
    error,
    fetchList,
  };
};

